module.exports = __webpack_public_path__ + "static/media/background-home.c3e7b3eb.png";